import React from 'react';
import styles from './styles';
import SurveyQuestions from "../../../SurveyQuestions";

const PrescreenQuestions = props => {

    return(
        <div style={styles.container}>
            <div style={styles.editPanel}>
                <SurveyQuestions
                    {...props}
                    overviewForm={props.data}
                    type="prescreenQuestions"
                    updateQuestions={(data) => props.setDiff('prescreenQuestions', data)}
                    instance={props.instanceSettings && props.instanceSettings.formattedName}
                    instanceSettings={props.instanceSettings}
                    edit={true}
                />
            </div>
        </div>
    )
}

export default PrescreenQuestions;
